import type { SelectOption } from '../../../../../components';
import { GS_DECISION } from './constant';

export const GSReturnOptions: SelectOption[] = [
  { label: 'to DoRPgS', value: GS_DECISION.RETURN_TO_DORPGS },
  { label: 'to FRC/SB', value: GS_DECISION.RETURN_TO_FRCSB },
];
